import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateOrganizerBlockInput, OrganizerBlockDto } from '@upme/contracts';
import { api } from '../../app/api-client';
import { organizerBlocksKey } from './queries';

export function useBlockOrganizer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateOrganizerBlockInput) =>
      api.post('admin/organizer-blocks', { json: body }).json<OrganizerBlockDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...organizerBlocksKey] }),
  });
}

export function useUnblockOrganizer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`admin/organizer-blocks/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [...organizerBlocksKey] }),
  });
}
